import React from "react";
import {RegionalPartner} from "../Interfaces/RegionalPartner";
import i18n from "i18next";
import {Offer} from "../Interfaces/Offer";
import {Email} from "react-obfuscate-email";

type Props = {
    regionalPartner: RegionalPartner
}

class ListItem extends React.Component<Props, any> {
    render() {
        return (
            <div className="list-item">
                <div className={"list-item-wrapper"}>
                    <h2 className={"list-item-title"}>
                        {this.props.regionalPartner.title}
                    </h2>

                    <div className={"list-item-data"}>
                        <div className={"list-item-left"}>
                            <div className={"address"}>{this.props.regionalPartner.address}</div>
                            <div className={"zip-city"}>CH-{this.props.regionalPartner.zip} {this.props.regionalPartner.city}</div>

                            {
                                this.props.regionalPartner.phone ?
                                    <div className={"phone"}>
                                        <a href={"tel:" + this.props.regionalPartner.phone.replace(/\s/g, '')} target={'_blank'} rel={'noreferrer'}>
                                            {this.props.regionalPartner.phone}
                                        </a>
                                    </div>
                                : ''
                            }

                            {
                                this.props.regionalPartner.email ?
                                    <div className={"email"}>
                                        <Email email={this.props.regionalPartner.email} target={'_blank'} rel={'noreferrer'}>
                                            {this.props.regionalPartner.email.replace('@', ' (at) ')}
                                        </Email>
                                    </div>
                                : ''
                            }
                        </div>

                        {
                            this.props.regionalPartner.offers.length > 0 ?
                                <div className={"list-item-right"}>
                                    <div className={"offers-title"}>
                                        {i18n.t('offersTitle')}
                                    </div>

                                    <ul className={"offers-list"}>
                                        {this.props.regionalPartner.offers.map((offer:Offer, index: number) => {
                                            return <li key={index}>{offer}</li>
                                        })}
                                    </ul>
                                </div>
                            : ''
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default ListItem
